import { publicAxios, securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";
export default {
  namespaced: true,
  state: {
    changePassword: {
      dialog: false,
    },
    trocarEmpresa: {
      dialog: false,
    },
    usuarioAtivo: JSON.parse(localStorage.getItem("usuarioAtivo")),
    empresaAtiva: JSON.parse(localStorage.getItem("empresaAtiva")),
    usuarios: [],
  },
  mutations: {
    toggleChangePasswordDialog(state, value) {
      state.changePassword.dialog = value;
    },
    trocarEmpresaDialog(state, value) {
      state.trocarEmpresa.dialog = value;
    },
    setUsuarioAtivo(state, usuarioAtivo) {
      localStorage.setItem("usuarioAtivo", JSON.stringify(usuarioAtivo));
      state.usuarioAtivo = usuarioAtivo;
    },
    setEmpresaAtiva(state, empresaAtiva) {
      localStorage.setItem("empresaAtiva", JSON.stringify(empresaAtiva));
      state.empresaAtiva = empresaAtiva;
    },
    carregarUsuarios(state, usuarios) {
      state.usuarios = usuarios;
    },
  },
  actions: {
    async login({ commit }, userInfo) {
      try {
        const response = await publicAxios.post("/login", userInfo);
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("refreshToken", response.data.refresh_token);
        commit("setUsuarioAtivo", response.data.usuario);
        commit("setEmpresaAtiva", response.data.empresa_ativa);
        return Promise.resolve(true);
      } catch (err) {
        if (err.response && err.response.status === 401) {
          commit(
            "ui/setSnackbar",
            {
              text: "Usuário e senha inválidos.",
            },
            { root: true }
          );
        }
        return Promise.resolve(false);
      }
    },
    async alterarSenha({ state, commit }, dados) {
      try {
        const response = await securedAxios.put(
          `/usuarios/${state.usuarioAtivo.id}/alterar-senha`,
          dados
        );
        response;
        return Promise.resolve(true);
      } catch (err) {
        if (err.response && err.response.status === 400) {
          commit(
            "ui/setSnackbar",
            { text: err.response.data.error },
            { root: true }
          );
        }
        return Promise.resolve(false);
      }
    },
    logout({ commit }) {
      commit("setUsuarioAtivo", null);
      commit("setEmpresaAtiva", null);
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
    },
    async listar({ commit }, filtros) {
      try {
        const response = await securedAxios.get(
          `/usuarios?opcoes=${urljson(filtros)}`
        );
        commit("carregarUsuarios", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    carregarUsuario(context, { id, filtros }) {
      return securedAxios.get(`/usuarios/${id}?opcoes=${urljson(filtros)}`);
    },
    async gravar(context, { usuario, permissoes, empresas }) {
      let promiseUsuario = null;

      if (usuario.id === "") {
        delete usuario.id;
        promiseUsuario = securedAxios.post("/usuarios", usuario);
      } else {
        promiseUsuario = securedAxios.put(`/usuarios/${usuario.id}`, usuario);
      }

      try {
        const response = await promiseUsuario;
        await securedAxios.post(`/usuarios/${response.data.id}/permissoes`, {
          permissoes,
        });
        await securedAxios.post(`/usuarios/${response.data.id}/empresas`, {
          associacoes: empresas,
        });
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async checar(context, login) {
      if (login === "") {
        return Promise.resolve(false);
      }
      try {
        const response = await securedAxios.get(`/usuarios/checar/${login}`);
        return Promise.resolve(!response.data.existe);
      } catch (e) {
        console.log(e);
        return Promise.resolve(true);
      }
    },
    async trocarEmpresa({ commit }, id_empresa) {
      try {
        const response = await securedAxios.post("/trocar-empresa", {
          token: localStorage.getItem("authToken"),
          id_empresa,
        });
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("refreshToken", response.data.refresh_token);
        commit("setUsuarioAtivo", response.data.usuario);
        commit("setEmpresaAtiva", response.data.empresa_ativa);
        return Promise.resolve(true);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
